const basePath = process.env.REACT_APP_API_PATH;
export const APIPath = {
  server: `${basePath}/api`,

  wakeUpDB: "db/start",
  congestions: "congestions",
  congestionsRealTime: "congestions/real-time",
  congestionsAvg: "congestions/avg",
  substations: "substations",
  geoLayers: "geo-layers",
  customLayers: "custom-layers",
  customLayersRequest: "custom-layers/request",
  customLayerUpload: "custom-layers/upload",
};
